import { ContractTermsData, ContractTermsForm } from "./ContractTermsForm";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import { Button } from "@/components/ui/button";

export type ContractDetails = ContractTermsData;

interface PartnershipTermsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  contractDetails: ContractDetails;
  onContractDetailsChange: (details: ContractDetails) => void;
  onSubmit: () => void;
  isSubmitting?: boolean;
  title?: string;
  description?: string;
  submitButtonText?: string;
  maxEndDate?: number; // Maximum allowed end date (e.g., campaign end date)
}

export function PartnershipTermsDialog({
  open,
  onOpenChange,
  contractDetails,
  onContractDetailsChange,
  onSubmit,
  isSubmitting = false,
  title = "Set Contract Terms",
  description = "Set the terms for the partnership contract. The creator will need to approve these terms.",
  submitButtonText = "Send Proposal",
  maxEndDate,
}: PartnershipTermsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[800px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <ContractTermsForm
            contractData={contractDetails}
            onContractDataChange={onContractDetailsChange}
            showDateFields={true}
            maxEndDate={maxEndDate}
          />
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            type="button"
          >
            Cancel
          </Button>
          <Button onClick={onSubmit} disabled={isSubmitting} type="button">
            {isSubmitting ? "Sending..." : submitButtonText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
